import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Fridge } from '../../../types/mpup-types'
import { MpupAccessPassesService } from '../../../services/mpup-access-passes.service'

@Component({
  selector: 'mb-mpup-fridge-select',
  templateUrl: './mpup-fridge-select.component.html',
  styleUrls: ['./mpup-fridge-select.component.scss']
})
export class MpupFridgeSelectComponent {

  @Input()
  fridges!: ReadonlyArray<Fridge>
  @Input()
  selectedFridge!: Fridge | null
  @Output()
  selectFridge = new EventEmitter<Fridge>()

  constructor (protected accessPassesService: MpupAccessPassesService) {
  }

  onSelectFridge (id: string) {
    const fridge = this.fridges.find(f => f.fridgeId === id)

    if(fridge !== undefined) {
      this.selectFridge.emit(fridge)
    }
  }

  getLocation (): string {
    const locationKeys = ['location', 'name3', 'street', 'zip', 'city']
    const fridge = this.selectedFridge
    if(fridge) {
      return Object.entries(fridge)
        .filter(([key]) => locationKeys.includes(key))
        .filter(([, value]) => value !== undefined && value !== '')
        .sort(([a], [b]) => locationKeys.findIndex(v => v ===a) - locationKeys.findIndex(v => v ===b))
        .map(([, value]) => value)
        .join(', ')
    }
    return ''
  }
}
